import React, { useEffect, useState } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import supabase from '../../../../../supabaseClient';

function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

async function fetchActiveAnnouncementsFor(profileType, idConfig) {
  const today = todayISO();
  const { data, error } = await supabase
    .from('noticeboard')
    .select('id, content, date_from, date_to')
    .contains('target_profile_types', [profileType])
    .eq('id_configuration', idConfig )
    .lte('date_from', today)
    .gte('date_to', today)
    .order('date_from', { ascending: false });
  if (error) throw error;
  return data;
}

function NoticeboardForWorker({ profileType, idConfig }) {
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    if (!idConfig) return;
    let cancelled = false;
    fetchActiveAnnouncementsFor(profileType, idConfig)
      .then((data) => { if (!cancelled) setAnnouncements(data); })
      .catch((err) => console.error('Błąd pobierania ogłoszeń:', err));
    return () => { cancelled = true; };
  }, [profileType, idConfig]);

  if (announcements.length === 0) return null;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={{ textAlign: 'center', fontWeight: 800, fontSize: 30, color: '#6B1D2F', mb: 1.5, letterSpacing: '0.02em' }}>
        Ogłoszenie
      </Typography>

      <Stack spacing={1.25}>
        {announcements.map((item) => (
          <Box
            key={item.id}
            sx={{
              background: '#fff',
              borderRadius: '10px',
              padding: '14px 20px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: '14px',
              animation: 'noticeboardSlideIn 0.4s ease-out, noticeboardBorderPulse 1.6s ease-in-out infinite',
              '@keyframes noticeboardSlideIn': {
                from: { opacity: 0, transform: 'translateY(-8px)' },
                to: { opacity: 1, transform: 'translateY(0)' },
              },
              '@keyframes noticeboardBorderPulse': {
                '0%, 100%': { boxShadow: 'inset 4px 0 0 0 #c0392b, 0 2px 8px rgba(192,57,43,0.15)' },
                '50%': { boxShadow: 'inset 4px 0 0 0 #ff6b5e, 0 2px 20px rgba(192,57,43,0.45)' },
              },
            }}
          >
            <Box
              component="span"
              sx={{
                fontSize: 28,
                display: 'inline-block',
                animation: 'noticeboardBellPulse 1.6s ease-in-out infinite',
                '@keyframes noticeboardBellPulse': {
                  '0%, 100%': { transform: 'scale(1)', opacity: 1 },
                  '50%': { transform: 'scale(1.15)', opacity: 0.7 },
                },
              }}
            >
              🔔
            </Box>
            <Box>
              <Typography sx={{ fontSize: 22, color: '#2C1419', fontWeight: 600 }}>{item.content}</Typography>
              <Typography sx={{ fontSize: 15, color: '#a89a9a', mt: 0.5 }}>Obowiązuje do {item.date_to}</Typography>
            </Box>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}

export default NoticeboardForWorker;